export default function DeclineCallIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_15736_1708)">
        <rect
          x="9.78882"
          y="6.52588"
          width="48.9441"
          height="48.9441"
          rx="24.472"
          fill="#F44336"
          shape-rendering="crispEdges"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.1627 19.4099C28.7847 17.4609 26.0272 17.132 24.3601 18.8872L22.2261 21.1338C21.4976 21.9008 20.9439 22.9663 21.0106 24.2085C21.1455 26.7226 22.213 31.8684 27.8323 37.7844C33.8543 44.1245 39.5986 44.4433 42.0783 44.1985C43.0939 44.0983 43.9159 43.5566 44.5186 42.922L46.4499 40.8886C48.2241 39.0207 47.7074 35.8949 45.4874 34.617L42.8899 33.122C41.3965 32.2624 39.5443 32.5088 38.3564 33.7594L37.8008 34.3443C37.7614 34.3582 37.6379 34.3915 37.4018 34.3532C36.8546 34.2643 35.6735 33.7812 33.7265 31.7313C31.7855 29.6878 31.3074 28.4292 31.2166 27.8099C31.1729 27.5111 31.2173 27.3537 31.2349 27.3043L31.2378 27.2964L31.5707 26.9459C32.8862 25.561 32.9793 23.3936 31.8771 21.8347L30.1627 19.4099ZM25.8387 20.2916C26.5496 19.5433 27.8009 19.602 28.4975 20.5872L30.2119 23.012C30.7858 23.8237 30.6978 24.9038 30.0921 25.5415L29.7022 25.952L30.425 26.6386C29.7021 25.952 29.7012 25.953 29.7003 25.954L29.6983 25.956L29.6944 25.9603L29.6861 25.9693L29.668 25.9897C29.6553 26.0043 29.6413 26.021 29.6264 26.0399C29.5965 26.0777 29.5627 26.1241 29.5272 26.1795C29.4561 26.2907 29.3789 26.437 29.3136 26.6206C29.1808 26.9939 29.1084 27.4882 29.1988 28.1056C29.3766 29.3184 30.1713 30.9495 32.2478 33.1357C34.3182 35.3155 35.8819 36.1724 37.0749 36.3661C37.6871 36.4656 38.1826 36.3862 38.5579 36.2382C38.7413 36.1658 38.8864 36.0809 38.9953 36.0036C39.0496 35.9651 39.0949 35.9285 39.1314 35.8965C39.1497 35.8805 39.1658 35.8655 39.1798 35.852L39.1993 35.8328L39.2079 35.824L39.212 35.8198L39.2139 35.8178C39.2148 35.8168 39.2158 35.8158 38.4991 35.135L39.2158 35.8158L39.835 35.1639C40.359 34.6122 41.1756 34.4882 41.8726 34.8894L44.47 36.3845C45.586 37.0269 45.8044 38.607 44.9713 39.4842L43.04 41.5175C42.6606 41.9169 42.2637 42.131 41.8779 42.169C39.927 42.3616 34.8364 42.1973 29.3109 36.38C24.0411 30.8318 23.1572 26.1519 23.047 24.0992C23.0178 23.5563 23.2542 23.0126 23.7048 22.5383L25.8387 20.2916Z"
          fill="white"
        />
        <path
          d="M40.4201 19.4004C40.0219 19.0022 39.3763 19.0022 38.9781 19.4004C38.5799 19.7987 38.5799 20.4443 38.9781 20.8425L40.9762 22.8406L38.9781 24.8387C38.5799 25.2369 38.5799 25.8825 38.9781 26.2807C39.3763 26.6789 40.0219 26.6789 40.4201 26.2807L42.4182 24.2826L44.4163 26.2807C44.8145 26.6789 45.4601 26.6789 45.8583 26.2807C46.2565 25.8825 46.2565 25.2369 45.8583 24.8387L43.8602 22.8406L45.8583 20.8425C46.2565 20.4443 46.2565 19.7987 45.8583 19.4005C45.4601 19.0023 44.8145 19.0023 44.4163 19.4005L42.4182 21.3986L40.4201 19.4004Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15736_1708"
          x="-1.90735e-06"
          y="-1.43051e-06"
          width="68.5217"
          height="68.5217"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.26294" />
          <feGaussianBlur stdDeviation="4.89441" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15736_1708"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15736_1708"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
